import React, { FunctionComponent } from 'react'
import useTranslation from '../../hooks/useTranslation'
import Vehicle from '../../entities/Vehicle'
import useOnMount from '../../hooks/useOnMount'
import LoadingIndicatorWrapper from '../loading-indicator-wrapper'
import { Spinner } from '../../base-components/spinner'
import style from './userGarage.css'
import UserGarageVehicle from '../user-garage-vehicle'
import UserGarageVehicleItemsPlaceholder
    from '../user-garage-vehicle/UserGarageVehicleItemsPlaceholder'

export type Props = {
    userGarageVehicles: Vehicle[]
    loadUserGarageInfo: () => {}
    isLoading: boolean
}

const UserGarage: FunctionComponent<Props> = (props) => {
    const { userGarageVehicles, loadUserGarageInfo, isLoading } = props
    const { t } = useTranslation()

    useOnMount(() => {
        loadUserGarageInfo && loadUserGarageInfo()
    })

    const hasVehicles = userGarageVehicles && userGarageVehicles.length > 0
    const isInitialLoading = isLoading && !hasVehicles

    const vehicleElements = isInitialLoading
        ? <UserGarageVehicleItemsPlaceholder />
        : userGarageVehicles.map((vehicle) => (
            <UserGarageVehicle
                key={vehicle.vehicleCode}
                vehicle={vehicle}
            />
        ))

    return (
        <div className={style.container} data-testid="page-garage">
            <section className={style.headerContainer}>
                <h1 className={style.title} data-testid="user-garage-title">
                    {t('garage.userGarage.heading')}
                </h1>
            </section>
            <div className={style.loadingIndicator}>
                {isLoading && hasVehicles && (
                    <>
                        <Spinner height="16px" width="16px" />
                        <span className={style.loadingText}>
                            {t('garage.userGarage.vehicleListUpdate')}
                        </span>
                    </>
                )}
            </div>
            {isInitialLoading ? (
                <LoadingIndicatorWrapper isLoading={true}>
                    <div className={style.content}>
                        {vehicleElements}
                    </div>
                </LoadingIndicatorWrapper>
            ) : (
                <div className={style.content}>
                    {vehicleElements}
                </div>
            )}
        </div>
)
}

export default UserGarage
